export const generateDeterministicPreviousTreatmentStringFromPatientQuote = (
  patientQuote: string,
) => {
  const priorTreatmentStrings = [
    'Received no prior treatments',
    'Received 1 prior treatment',
    'Received 2+ prior treatments',
  ]
  return priorTreatmentStrings[
    patientQuote.length % priorTreatmentStrings.length
  ]!
}
